module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.cab7cf40.png";